import { useState, useEffect } from "react";
import type { PaymentMethod } from "@ascente/shared-types";
import { useApp } from "../../context/AppContext.js";

export function Settings() {
  const { config, handleSaveSettings, userName } = useApp();

  const [companyName, setCompanyName] = useState(config.companyName ?? "");
  const [companyContact, setCompanyContact] = useState(config.companyContact ?? "");
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(config.paymentMethod ?? "e-transfer");
  const [etransferEmail, setEtransferEmail] = useState(config.etransferEmail ?? "");
  const [chequeAddress, setChequeAddress] = useState(config.chequeAddress ?? "");
  const [saved, setSaved] = useState(false);

  // Sync with config when it loads
  useEffect(() => {
    if (config.companyName !== undefined) setCompanyName(config.companyName);
    if (config.companyContact !== undefined) setCompanyContact(config.companyContact);
    if (config.paymentMethod !== undefined) setPaymentMethod(config.paymentMethod);
    if (config.etransferEmail !== undefined) setEtransferEmail(config.etransferEmail);
    if (config.chequeAddress !== undefined) setChequeAddress(config.chequeAddress);
  }, [config]);

  const handleSave = async () => {
    // Only claim success when the server actually accepted it. The failure
    // itself is already on screen in the header's sync indicator.
    const ok = await handleSaveSettings({ companyName, companyContact, paymentMethod, etransferEmail, chequeAddress });
    if (!ok) return;
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="card" style={{ maxWidth: 560 }}>
      <h3 className="section-title">Business Settings</h3>

      <div className="form-group">
        <label className="inp-label">Signed in as</label>
        <input className="inp" value={userName} readOnly style={{ opacity: 0.7 }} />
      </div>

      <div className="form-group">
        <label className="inp-label">Company Name</label>
        <input className="inp" placeholder="Your company name" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
      </div>

      <div className="form-group">
        <label className="inp-label">Company Contact Info</label>
        <textarea className="inp" rows={4} placeholder={"Address line 1\nAddress line 2\nPhone / Email"} value={companyContact} onChange={(e) => setCompanyContact(e.target.value)} />
      </div>

      <div className="form-group">
        <label className="inp-label">Payment Method on Invoices</label>
        <select className="sel" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value as PaymentMethod)}>
          <option value="e-transfer">E-Transfer Only</option>
          <option value="cheque">Cheque Only</option>
          <option value="both">Both</option>
        </select>
      </div>

      {(paymentMethod === "e-transfer" || paymentMethod === "both") && (
        <div className="form-group">
          <label className="inp-label">E-Transfer Email</label>
          <input className="inp" type="email" placeholder="payments@example.com" value={etransferEmail} onChange={(e) => setEtransferEmail(e.target.value)} />
        </div>
      )}

      {(paymentMethod === "cheque" || paymentMethod === "both") && (
        <div className="form-group">
          <label className="inp-label">Cheque Payable To / Address</label>
          <textarea className="inp" rows={3} placeholder={"Company Name\nMailing Address"} value={chequeAddress} onChange={(e) => setChequeAddress(e.target.value)} />
        </div>
      )}

      <button className="btn btn-primary" onClick={() => void handleSave()}>
        {saved ? "✓ Saved" : "Save Settings"}
      </button>
    </div>
  );
}
